import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 30000 });

const get = (url, params) => api.get(url, { params }).then((r) => r.data);

export const fetchers = {
  leagues: () => get("/leagues"),
  byDate: (league = "all", date) => get("/matches", { league, date, tz: -new Date().getTimezoneOffset() }),
  upcoming: (league = "all", limit = 60) => get("/matches/upcoming", { league, limit }),
  past: (league = "all", limit = 60) => get("/matches/past", { league, limit }),
  live: () => get("/matches/live"),
  standings: (league = "epl") => get("/standings", { league }),
  teams: (league = "epl") => get("/teams", { league }),
  team: (id, league) => get(`/team/${id}`, { league }),
  news: (params = {}) => get("/news", params),
  article: (slug) => get(`/news/${slug}`),
};

export const ymd = (d) =>
  `${d.getFullYear()}${String(d.getMonth() + 1).padStart(2, "0")}${String(d.getDate()).padStart(2, "0")}`;
